import { Link } from "react-router-dom";
import { Clock, ShieldOff } from "lucide-react";

import type { WorkerStatus } from "@/features/workers/types";

interface Props {
  status: WorkerStatus;
}

export function PendingReviewView({ status }: Props) {
  if (status === "SUSPENDED") {
    return (
      <div className="rounded-lg border border-destructive bg-destructive-light p-6 text-center">
        <ShieldOff className="mx-auto mb-3 h-10 w-10 text-destructive-foreground" />
        <h2 className="text-base font-semibold text-destructive-foreground">
          Your account is suspended
        </h2>
        <p className="mt-2 text-sm text-destructive-foreground">
          Reach out to support@oneshift.ca to resolve this and reactivate your
          account.
        </p>
      </div>
    );
  }

  // PENDING (and any future non-APPROVED states default here)
  return (
    <div className="rounded-lg border border-border bg-surface p-8 text-center shadow-card">
      <Clock className="mx-auto mb-3 h-10 w-10 text-copy-muted" />
      <h2 className="text-base font-semibold text-copy">
        We're reviewing your application
      </h2>
      <p className="mt-2 text-sm text-copy-muted">
        Our team verifies every worker before they can browse and apply to
        shifts. You'll get an email the moment you're approved — usually within
        one business day.
      </p>
      <p className="mt-4 text-xs text-copy-muted">
        Need to update something while you wait?{" "}
        <Link
          to="/worker/profile"
          className="font-medium text-primary hover:underline"
        >
          Edit your profile
        </Link>
      </p>
    </div>
  );
}
